import React, { useEffect, useRef, useState } from "react";
import CompanyLogo from "assets/studyGramLogo/studygram_logo.png";
import { query, collection, getDocs, getDoc, doc } from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Dateformat from "helper/constant/timeFormat";
import html2pdf from "html2pdf.js";
import { Button } from "primereact/button";
import "./index.css";


const SalarySlip = () => {
  const [profileData, setProfileData] = useState([]);
  const navigate = useNavigate();
  const [teacherSalary, setTeacherSalary] = useState({
    basic: null,
    hra: null,
    conveyance: null,
    other: null,
    teacherData: null,
  });

  const location = useLocation();
  let daysInCurrentMonth = moment(location.state.salary_month_num).daysInMonth();
  const contentRef = useRef(null);

  const options = {
    filename: "my-document.pdf",
    margin: [1.5, 0, 0, 0],
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
  };

  const convertToPdf = () => {
    const content = contentRef.current;

    html2pdf().set(options).from(content).save();
  };

  // MARK: use effect function
  useEffect(() => {
    if (location.state) {
      calculateHalfOfSalary()
    }
    getProfileData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchTeachersApi() {
    const docRef = doc(dbFirestore, TableName.teachers, location.state.teacher_id)
    const docSnap = await getDoc(docRef);
    return docSnap.exists() ? docSnap.data() : null;
  }

  // MARK: calaculate salary of month
  const calculateHalfOfSalary = async () => {
    const  singleTeacherData = await fetchTeachersApi();

    const salaryAmount = location.state?.salary_num;

    const halfSalary = salaryAmount / 2;

    const forthPortionFromSalary = halfSalary / 4;

    const quarterhalf = (halfSalary - forthPortionFromSalary) / 2;

    setTeacherSalary({
      basic: halfSalary,
      hra: quarterhalf,
      conveyance: quarterhalf,
      other: forthPortionFromSalary,
      teacherData: singleTeacherData
    })
  };


  // MARK: get data from profile module
  async function getProfileData() {
    let q = query(
      collection(dbFirestore, TableName.profile)
    );
    const querySnapshot = await getDocs(q);
    const profileArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));
    setProfileData(profileArray);
  }
  return (

    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <div className="d-flex">
             <div style={{ marginBottom: "1rem", paddingLeft: "1rem", flexGrow: "1" }}>
                      <Button icon="pi pi-arrow-left"
                        type="button"
                        onClick={() => navigate(-1)}
                        className="view__back_button me-3"
                      />
                    </div>
                    <div className="modules__salaryList_main-content mb-4">
            <button
              type="button"
              onClick={convertToPdf}
              className="modules__download_button"
            >
              Download Pdf
            </button>
            </div>
          </div>
          {teacherSalary && profileData && (
            <div className="main___div" ref={contentRef}>
              {profileData.map((profile, index) => (
                <div className="row" key={index}>
                  <div className="col-3 col-sm-4 top__left_col">
                    <img src={CompanyLogo} alt="" className="company___logo" />
                  </div>
                  <div className="col-9 col-sm-8 top__right_col">
                    <h1 className="mb-0 main___heading">
                      {profile.business_name}
                    </h1>
                    <div className="top__right_para_div">
                      <p className="mb-0 top__right_para">{profile.address}</p>
                      <p className="mb-2 top__right_para ">
                        Mob. : {profile.phone}, {profile.second_phone}
                      </p>
                    </div>
                    <p className="mb-0 pe-2 top__right_bottom-para">
                      Salary Slip For the Month of {moment(location.state.salary_month_num).format(Dateformat.MMMMYYYY)}
                    </p>
                  </div>
                </div>
              ))}

              <div
                className="pt-1 pb-1"
                style={{
                  borderTop: "3px solid var(--red-color)",
                  paddingBottom: "2px",
                }}
              >

                <div className="row m-auto">
                  <div className="col mb-0">
                    <p
                      className="mb-0"
                      style={{ textTransform: "capitalize", marginLeft: "5px" }}
                    >
                      Emp. Name:- {teacherSalary.teacherData?.name}
                    </p>
                  </div>
                  <div className="col mb-0">
                    <p className="mb-0" style={{ textTransform: "capitalize" }}>
                      Father's Name:- {teacherSalary.teacherData?.father_husband_name}{" "}
                    </p>
                  </div>
                </div>

                <div className="row m-auto">
                  <div className="col mb-0">
                    <p
                      className="mb-0"
                      style={{ textTransform: "capitalize", marginLeft: "5px" }}
                    >
                      Department:- {teacherSalary?.teacherData?.department}
                    </p>
                  </div>
                  <div className="col mb-0">
                    <p className="mb-0" style={{ textTransform: "capitalize" }}>
                      Designation:- {teacherSalary.teacherData?.designation}
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div className="row table-right-border table__heading row__table">
                  <div className="col mb-0 table--heading">
                    <p className="mb-0 table__top_heading">total days (a) </p>
                  </div>

                  <div className="col mb-0 table--heading">
                    <p className="mb-0 table__top_heading">rate of pay (b) </p>
                  </div>

                  <div className="col mb-0">
                    <p className="mb-0 table__top_heading">salary earned (c)</p>
                  </div>
                </div>

                <div className="row row__table">
                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p className="mb-0 column__para">Worked</p>
                      </div>
                      <div className="col-6">
                        <p className="mb-0 table__right_col">
                          {location.state.no_of_days}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p className="mb-0 column__para">Basic</p>
                      </div>
                      <div className="col-6">
                        {" "}
                        <p className="mb-0 table__right_col">{teacherSalary.basic}</p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0">
                    <div className="row table__col__row">
                      <div className="col-6"></div>
                      <div className="col-6">
                        {" "}
                        <p className="mb-0 table__right_col">
                          {location.state.salary_num}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row row__table">
                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p className="mb-0 column__para">Rest</p>
                      </div>
                      <div className="col-6">
                        {" "}
                        <p className="mb-0 table__right_col">{daysInCurrentMonth - location.state.no_of_days}</p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p className="mb-0 column__para">H.R.A.</p>
                      </div>
                      <div className="col-6">
                        {" "}
                        <p className="mb-0 table__right_col">{teacherSalary.hra}</p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p></p>
                      </div>
                      <div className="col-6">
                        <p className="mb-0 table__right_col">-</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row row__table">
                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p className="mb-0 column__para">C.L.</p>
                      </div>
                      <div className="col-6">
                        {" "}
                        <p className="mb-0 table__right_col">-</p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p className="mb-0 column__para">Conveyance</p>
                      </div>
                      <div className="col-6">
                        {" "}
                        <p className="mb-0 table__right_col">{teacherSalary.conveyance}</p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0">
                    <div className="row table__col__row">
                      <div className="col-6"></div>
                      <div className="col-6">
                        {" "}
                        <p className="table__right_col">-</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row row__table">
                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p className="mb-0 column__para">E.L.</p>
                      </div>
                      <div className="col-6">
                        {" "}
                        <p className="table__right_col">-</p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p className="mb-0 column__para">Others</p>
                      </div>
                      <div className="col-6">
                        {" "}
                        <p className="table__right_col">{teacherSalary.other}</p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0">
                    <div className="row table__col__row">
                      <div className="col-6"></div>
                      <div className="col-6">
                        {" "}
                        <p className="table__right_col">-</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row row__table">
                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p className="mb-0 column__para">Holidays</p>
                      </div>
                      <div className="col-6">
                        {" "}
                        <p className="table__right_col">-</p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0 table__data"></div>

                  <div className="col mb-0"></div>
                </div>

                <div
                  className="row row__table"
                  style={{
                    textTransform: "uppercase",
                    borderTop: "3px solid black",
                    borderBottom: "3px solid var(--red-color)",
                  }}
                >
                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6">
                        <p className="mb-0 column__para">Total</p>
                      </div>
                      <div className="col-6">
                        {" "}
                        <p className="table__right_col">{daysInCurrentMonth}</p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0 table__data">
                    <div className="row table__col__row">
                      <div className="col-6"></div>
                      <div className="col-6">
                        {" "}
                        <p className="table__right_col">{location.state?.salary_num}</p>
                      </div>
                    </div>
                  </div>

                  <div className="col mb-0">
                    <div className="row table__col__row">
                      <div className="col-6"></div>
                      <div className="col-6">
                        {" "}
                        <p className="table__right_col">{location.state?.salary_num}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "rgba(255,251,177,255)",
                  fontWeight: "500",
                }}
              >
                <p
                  className="mb-0 "
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  NET AMOUNT PAYABLE(C-D): Rs.{location.state?.salary_num} (Rupees
                  Sixteen Thousand Only)
                </p>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default SalarySlip;
